import { render, staticRenderFns } from "./printTasksDetails.vue?vue&type=template&id=2bf39eb6&scoped=true&"
import script from "./printTasksDetails.vue?vue&type=script&lang=js&"
export * from "./printTasksDetails.vue?vue&type=script&lang=js&"
import style0 from "./printTasksDetails.vue?vue&type=style&index=0&id=2bf39eb6&lang=scss&scoped=true&"
import style1 from "./printTasksDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf39eb6",
  null
  
)

export default component.exports